import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ButtonWithSpinner, Card, Text } from '@reveni-io/reveni-ui'

import useRating from './hooks/useRating/useRating'
import Star from './Star/Star'
import { shouldShowRating } from './helpers'
import * as Styles from './styles'

const Rating = ({ size = 5, status, trackingId, customerRatingBlockEnabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { rating, isSelected, onSelect, handleHoverRating, onSubmit, submitting, ratingSubmitted } = useRating({
    trackingId,
  })

  if (!shouldShowRating({ status, customerRatingBlockEnabled })) return null

  return (
    <Card>
      <Styles.MainContainer>
        <Text type="titleM" color={theme.colors.primary.tone900}>
          {t('Valora tu experiencia con nosotros')}
        </Text>
        <Styles.RatingContainer>
          {[...Array(size)].map((rating, index) => (
            <Star
              key={index}
              index={index}
              isSelected={isSelected(index + 1)}
              handleHoverRating={handleHoverRating}
              onSelect={onSelect}
            />
          ))}
        </Styles.RatingContainer>
        {ratingSubmitted ? (
          <Text type="titleM" color={theme.colors.primary.tone900}>
            {t('¡Gracias!')}
          </Text>
        ) : (
          <ButtonWithSpinner
            defaultLabel={t('Enviar')}
            loadingLabel={t('Enviando')}
            loading={submitting}
            fullWidth
            variant="outlined"
            disabled={!rating || submitting}
            onClick={onSubmit}
          />
        )}
      </Styles.MainContainer>
    </Card>
  )
}

export default Rating
